import { ReactNode } from "react";

type TFrameDocumentProps = {
  crumb: string;
  actions?: ReactNode;
  fill?: boolean;
  children: ReactNode;
};

export function FrameDocument({ crumb, actions, fill, children }: TFrameDocumentProps) {
  return (
    <div className="relative w-full min-w-0 h-full bg-white flex flex-col shadow-[0px_51px_14px_0px_rgba(24,24,27,0),0px_33px_13px_0px_rgba(24,24,27,0),0px_18px_11px_0px_rgba(24,24,27,0.01),0px_8px_8px_0px_rgba(24,24,27,0.01),0px_2px_5px_0px_rgba(24,24,27,0.02)]">
      {/* Same header as the creation flow: page title on the left, actions on the right. */}
      <div className="h-14 shrink-0 border-b border-innoveraZinc-100 flex items-center justify-between gap-4 px-4">
        <p className="flex-1 min-w-0 truncate text-[16px] font-medium leading-[25px] tracking-[-0.16px] text-innoveraZinc-900">
          {crumb}
        </p>
        {actions}
      </div>
      {fill ? (
        <div className="flex-1 min-h-0 w-full">{children}</div>
      ) : (
        <div className="flex-1 min-h-0 overflow-y-auto px-4">
          <div className="flex justify-center w-full">
            <div className="w-[720px] max-w-full py-10">{children}</div>
          </div>
        </div>
      )}
    </div>
  );
}
